<template>
  <ul class="fontsizeul">
    <li>字号：</li>
    <li v-for="(item, index) in fontSizeArr" :key="index" @click.stop="changefontsize(item.sign)">{{ item.name }}</li>
  </ul>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      fontSizeArr: [
        {'name': '超大', 'sign': 'super'},
        {'name': '大', 'sign': 'large'},
        {'name': '标准', 'sign': 'standard'},
        {'name': '小', 'sign': 'small'}
      ],
      fontsizeType: 'standard'
    }
  },
  mounted () {
    this.$emit('fontsizeType', this.fontsizeType)
  },
  methods: {
    /* 改变字体大小 */
    changefontsize (val) {
      this.$emit('fontsizeType', val)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/selectfontsize/index.vue